import React, { useState } from 'react';

// Default wallpaper options
const wallpapers = [
  { id: 'wallpaper1', name: 'Wallpaper 1', path: '/assets/wallpapers/default.jpg' },
  { id: 'wallpaper2', name: 'Wallpaper 2', path: '/assets/wallpapers/custom.jpg' },
  { id: 'wallpaper3', name: 'Wallpaper 3', path: '/assets/wallpapers/custom2.png' },
  { id: 'wallpaper4', name: 'Wallpaper 4', path: '/assets/wallpapers/480538.png' },
  { id: 'wallpaper5', name: 'Wallpaper 5', path: '/assets/wallpapers/thumb-1920-1276648.png' }
];

const SettingsPlaceholder = ({ theme, initialSection, onThemeChange, onWallpaperChange }) => {
  const [activeSection, setActiveSection] = useState(initialSection && initialSection !== 'display' ? initialSection : 'personalize');
  const [notifications, setNotifications] = useState(true);
  const [dataSaving, setDataSaving] = useState(false);
  const [locationTracking, setLocationTracking] = useState(true);
  const [analytics, setAnalytics] = useState(true);
  const [animations, setAnimations] = useState(true);
  const [soundEffects, setSoundEffects] = useState(true);
  const [autoUpdate, setAutoUpdate] = useState(true);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      backgroundColor: 'rgba(10, 10, 20, 0.2)',
      backdropFilter: 'blur(10px)',
      color: '#fff',
      padding: '0',
      overflow: 'hidden'
    }}>
      {/* Settings Header */}
      <div style={{
        display: 'flex', 
        padding: '15px 20px',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
      }}>
        <h3 style={{ margin: 0 }}>Settings</h3>
      </div>
      
      {/* Settings Content */}
      <div style={{
        display: 'flex',
        height: 'calc(100% - 56px)',
        overflow: 'hidden'
      }}>
        {/* Settings Navigation */}
        <div style={{
          width: '200px',
          borderRight: '1px solid rgba(255, 255, 255, 0.1)',
          padding: '15px 0'
        }}>
          {['personalize', 'privacy', 'system', 'accessibility', 'about'].map(section => (
            <div 
              key={section}
              onClick={() => setActiveSection(section)}
              style={{
                padding: '10px 20px',
                cursor: 'pointer',
                backgroundColor: activeSection === section ? 'rgba(255, 255, 255, 0.1)' : 'transparent',
                color: activeSection === section ? 'white' : 'rgba(255, 255, 255, 0.7)',
                fontWeight: activeSection === section ? '500' : 'normal'
              }}
            >
              {section.charAt(0).toUpperCase() + section.slice(1)}
            </div>
          ))}
        </div>
        
        {/* Settings Panel */}
        <div style={{
          flex: 1,
          padding: '20px',
          overflowY: 'auto',
          overflowX: 'hidden'
        }}>
          {activeSection === 'personalize' && (
            <div>
              <h4>Wallpaper Settings</h4>
              <p>Select a wallpaper to personalize your desktop</p>
              
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
                gap: '15px',
                marginTop: '15px'
              }}>
                {wallpapers.map(wallpaper => (
                  <div 
                    key={wallpaper.id}
                    onClick={() => onWallpaperChange && onWallpaperChange(wallpaper.path)}
                    style={{
                      cursor: 'pointer',
                      transition: 'transform 0.2s',
                      position: 'relative'
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'scale(1.05)';
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = 'scale(1)';
                    }}
                  >
                    <div style={{
                      width: '100%',
                      paddingBottom: '70%',
                      backgroundImage: `url(${wallpaper.path})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      borderRadius: '8px',
                      border: '2px solid rgba(255, 255, 255, 0.2)'
                    }} />
                    <div style={{
                      marginTop: '5px',
                      fontSize: '12px',
                      textAlign: 'center'
                    }}>
                      {wallpaper.name}
                    </div>
                  </div>
                ))}
              </div>
              
              <div style={{ marginTop: '20px' }}>
                <h4>Custom Wallpaper</h4>
                <p>Enter URL for custom wallpaper image:</p>
                <div style={{ display: 'flex' }}>
                  <input 
                    type="text"
                    placeholder="https://example.com/image.jpg"
                    style={{
                      flex: 1,
                      padding: '8px 12px',
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      borderRadius: '4px',
                      color: 'white',
                      marginRight: '8px'
                    }}
                    id="custom-wallpaper-input"
                  />
                  <button
                    onClick={() => {
                      const input = document.getElementById('custom-wallpaper-input');
                      if (input && input.value && onWallpaperChange) {
                        onWallpaperChange(input.value);
                      }
                    }}
                    style={{
                      padding: '8px 12px',
                      backgroundColor: '#4a90e2',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer'
                    }}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          )}
          
          {activeSection === 'privacy' && (
            <div>
              <h4>Privacy Settings</h4>
              <p>Manage your privacy and security preferences</p>
              
              <div style={{ marginTop: '20px' }}>
                {[
                  { id: 'location', label: 'Location Services', state: locationTracking, setState: setLocationTracking, 
                    desc: 'Allow apps to request access to your location' },
                  { id: 'analytics', label: 'Usage Analytics', state: analytics, setState: setAnalytics, 
                    desc: 'Share anonymous usage data to improve WebOS' },
                  { id: 'cookies', label: 'Cookies Management', state: true, 
                    desc: 'Control how websites store cookies in your browser' },
                  { id: 'history', label: 'Browsing History', state: true, 
                    desc: 'Clear or manage your browsing history and cache' },
                  { id: 'passwords', label: 'Saved Passwords', state: true, 
                    desc: 'Manage saved passwords and credentials' }
                ].map(item => (
                  <div key={item.id} style={{ marginBottom: '15px', padding: '15px', backgroundColor: 'rgba(0,0,0,0.2)', borderRadius: '8px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div>
                        <h5 style={{ margin: '0 0 5px 0' }}>{item.label}</h5>
                        <p style={{ margin: 0, fontSize: '12px', opacity: 0.7 }}>{item.desc}</p>
                      </div>
                      <label className="switch" style={{ position: 'relative', display: 'inline-block', width: '48px', height: '24px' }}>
                        <input 
                          type="checkbox" 
                          checked={item.state} 
                          onChange={() => item.setState && item.setState(!item.state)}
                          style={{ opacity: 0, width: 0, height: 0 }}
                        />
                        <span style={{
                          position: 'absolute',
                          cursor: 'pointer',
                          top: 0, left: 0, right: 0, bottom: 0,
                          backgroundColor: item.state ? '#4a90e2' : 'rgba(255,255,255,0.2)',
                          borderRadius: '24px',
                          transition: '.3s',
                          '&:before': {
                            position: 'absolute',
                            content: '""',
                            height: '18px',
                            width: '18px',
                            left: item.state ? '26px' : '3px',
                            bottom: '3px',
                            backgroundColor: 'white',
                            borderRadius: '50%',
                            transition: '.3s'
                          }
                        }}>
                          <span style={{
                            position: 'absolute',
                            content: '""',
                            height: '18px',
                            width: '18px',
                            left: item.state ? '26px' : '3px',
                            bottom: '3px',
                            backgroundColor: 'white',
                            borderRadius: '50%',
                            transition: '.3s'
                          }}></span>
                        </span>
                      </label>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          
          {activeSection === 'system' && (
            <div>
              <h4>System Settings</h4>
              <p>Customize system behavior and performances</p>
              
              <div style={{ marginTop: '20px' }}>
                {[
                  { id: 'notifications', label: 'Notifications', state: notifications, setState: setNotifications, 
                    desc: 'Enable or disable system notifications' },
                  { id: 'data-saving', label: 'Data Saving Mode', state: dataSaving, setState: setDataSaving, 
                    desc: 'Reduce data usage by limiting background processes' },
                  { id: 'auto-update', label: 'Automatic Updates', state: autoUpdate, setState: setAutoUpdate, 
                    desc: 'Automatically install system updates' }
                ].map(item => (
                  <div key={item.id} style={{ marginBottom: '15px', padding: '15px', backgroundColor: 'rgba(0,0,0,0.2)', borderRadius: '8px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div>
                        <h5 style={{ margin: '0 0 5px 0' }}>{item.label}</h5>
                        <p style={{ margin: 0, fontSize: '12px', opacity: 0.7 }}>{item.desc}</p>
                      </div>
                      <label className="switch" style={{ position: 'relative', display: 'inline-block', width: '48px', height: '24px' }}>
                        <input 
                          type="checkbox" 
                          checked={item.state} 
                          onChange={() => item.setState(!item.state)}
                          style={{ opacity: 0, width: 0, height: 0 }}
                        />
                        <span style={{
                          position: 'absolute',
                          cursor: 'pointer',
                          top: 0, left: 0, right: 0, bottom: 0,
                          backgroundColor: item.state ? '#4a90e2' : 'rgba(255,255,255,0.2)',
                          borderRadius: '24px',
                          transition: '.3s'
                        }}>
                          <span style={{
                            position: 'absolute',
                            content: '""',
                            height: '18px',
                            width: '18px',
                            left: item.state ? '26px' : '3px',
                            bottom: '3px',
                            backgroundColor: 'white',
                            borderRadius: '50%',
                            transition: '.3s'
                          }}></span>
                        </span>
                      </label>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          
          {activeSection === 'accessibility' && (
            <div>
              <h4>Accessibility Settings</h4>
              <p>Customize WebOS to improve accessibility</p>
              
              <div style={{ marginTop: '20px' }}>
                {[
                  { id: 'animations', label: 'UI Animations', state: animations, setState: setAnimations, 
                    desc: 'Enable or disable interface animations' },
                  { id: 'sounds', label: 'Sound Effects', state: soundEffects, setState: setSoundEffects, 
                    desc: 'Enable or disable system sound effects' },
                  { id: 'high-contrast', label: 'High Contrast Mode', state: false, 
                    desc: 'Increase contrast for better visibility' },
                  { id: 'text-size', label: 'Text Size', state: 'Medium', type: 'select',
                    options: ['Small', 'Medium', 'Large', 'Extra Large'],
                    desc: 'Adjust the size of text throughout the system' }
                ].map(item => (
                  <div key={item.id} style={{ marginBottom: '15px', padding: '15px', backgroundColor: 'rgba(0,0,0,0.2)', borderRadius: '8px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div>
                        <h5 style={{ margin: '0 0 5px 0' }}>{item.label}</h5>
                        <p style={{ margin: 0, fontSize: '12px', opacity: 0.7 }}>{item.desc}</p>
                      </div>
                      {item.type === 'select' ? (
                        <select 
                          style={{
                            padding: '6px 10px',
                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                            color: 'white',
                            border: '1px solid rgba(255, 255, 255, 0.2)',
                            borderRadius: '4px'
                          }}
                        >
                          {item.options.map(option => (
                            <option key={option} value={option}>{option}</option>
                          ))}
                        </select>
                      ) : (
                        <label className="switch" style={{ position: 'relative', display: 'inline-block', width: '48px', height: '24px' }}>
                          <input 
                            type="checkbox" 
                            checked={item.state} 
                            onChange={() => item.setState && item.setState(!item.state)}
                            style={{ opacity: 0, width: 0, height: 0 }}
                          />
                          <span style={{
                            position: 'absolute',
                            cursor: 'pointer',
                            top: 0, left: 0, right: 0, bottom: 0,
                            backgroundColor: item.state ? '#4a90e2' : 'rgba(255,255,255,0.2)',
                            borderRadius: '24px',
                            transition: '.3s'
                          }}>
                            <span style={{
                              position: 'absolute',
                              content: '""',
                              height: '18px',
                              width: '18px',
                              left: item.state ? '26px' : '3px',
                              bottom: '3px',
                              backgroundColor: 'white',
                              borderRadius: '50%',
                              transition: '.3s'
                            }}></span>
                          </span>
                        </label>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          
          {activeSection === 'about' && (
            <div>
              <h4>About WebOS</h4>
              
              <div style={{ 
                padding: '20px', 
                backgroundColor: 'rgba(0,0,0,0.2)', 
                borderRadius: '8px',
                marginBottom: '20px' 
              }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                  <div style={{ 
                    width: '64px', 
                    height: '64px', 
                    borderRadius: '12px', 
                    backgroundColor: '#4a90e2',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontSize: '28px',
                    marginRight: '15px'
                  }}>
                    <i className="fas fa-desktop"></i>
                  </div>
                  <div>
                    <h3 style={{ margin: '0 0 5px 0' }}>WebOS</h3>
                    <p style={{ margin: 0, opacity: 0.7 }}>Version 1.0.0 (Build 2023.12.15)</p>
                  </div>
                </div>
                
                <p style={{ lineHeight: '1.6' }}>
                  WebOS is a modern, web-based operating system interface designed to provide a seamless desktop experience directly in your browser. Built with React and modern web technologies, WebOS offers a familiar yet innovative user experience with windows, apps, and a customizable interface.
                </p>
                
                <h5>Key Features:</h5>
                <ul style={{ paddingLeft: '20px', lineHeight: '1.6' }}>
                  <li>Intuitive windowing system with minimize, maximize, and close functions</li>
                  <li>Glass morphism design with beautiful transparency effects</li>
                  <li>Taskbar with app launching and window management</li>
                  <li>Desktop shortcuts and context menu functionality</li>
                  <li>Multiple built-in applications</li>
                  <li>Customizable wallpapers and themes</li>
                  <li>Persistent app state between sessions</li>
                </ul>
                
                <h5>System Information:</h5>
                <div style={{ 
                  backgroundColor: 'rgba(0,0,0,0.3)', 
                  padding: '10px', 
                  borderRadius: '4px',
                  fontSize: '13px',
                  fontFamily: 'monospace',
                  marginTop: '10px'
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                    <span>Browser:</span>
                    <span>{navigator.userAgent.split(' ').slice(-1)[0].split('/')[0]}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                    <span>Platform:</span>
                    <span>{navigator.platform}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                    <span>Screen:</span>
                    <span>{window.screen.width}x{window.screen.height}</span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span>Language:</span>
                    <span>{navigator.language}</span>
                  </div>
                </div>
                
                <div style={{ marginTop: '20px', textAlign: 'center', opacity: 0.7, fontSize: '12px' }}>
                  <p>© 2023 WebOS • All Rights Reserved</p>
                  <div style={{ marginTop: '5px' }}>
                    <a href="#" style={{ color: 'inherit', marginRight: '10px', textDecoration: 'none' }}>Privacy Policy</a>
                    <a href="#" style={{ color: 'inherit', marginRight: '10px', textDecoration: 'none' }}>Terms of Service</a>
                    <a href="#" style={{ color: 'inherit', textDecoration: 'none' }}>Contact</a>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SettingsPlaceholder; 